import React, { useState, useCallback, useMemo } from "react";
import styled from "styled-components";
import { styleTheme } from "../../../../style/theme";

import { TabState, TabValue, TabPropsType } from "../Tab.types";

import { TabContext } from "../context";

export const Tab: React.FC<TabPropsType> = (props) => {
  const [activeKey, setActiveKey] = useState(props.defaultKey);
  const [tabs, setTabs] = useState<TabValue[]>([]);
  const addTab = useCallback((title: string, key: string) => {
    setTabs((tabs) => {
      if (tabs.findIndex((item) => item.key === key) > 0) {
        return tabs;
      } else {
        return [...tabs, { title, key }];
      }
    });
  }, []);

  const tabState = useMemo<TabState>(
    () => ({
      activeKey,
      addItem: addTab,
    }),
    [activeKey, addTab]
  );

  return (
    <TabContext.Provider value={tabState}>
      <Wrapper>
        {tabs.map((value) => (
          <Pane
            key={value.key}
            data-active={value.key === activeKey}
            onClick={() => {
              setActiveKey(value.key)
              props.onChange(value.key)
            }}
            color={props.primaryColor}
            theme={{...styleTheme}}
          >
            {value.title}
          </Pane>
        ))}
      </Wrapper>
      {props.children}
    </TabContext.Provider>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Pane = styled.button`
  border: none;
  background: ${(props) => props.theme.colors.white};
  border-bottom: 1px solid ${(props) => props.theme.colors.gray.light};
  color: ${(props) => props.color};
  cursor: pointer;
  font-weight: bold;
  padding: 16px;
  text-align: center;
  transition: 0.2s;
  width: 100%;

  @media screen and (max-width: 1000px) {
    font-size: 12px;
  }

  &:hover {
    background: ${(props) => props.theme.colors.white};
    border-bottom: 5px solid ${(props) => props.theme.colors.white};
    color: ${(props) => props.color};

    @media screen and (max-width: 1000px) {
      border-width: 3px;
    }
  }

  &[data-active="true"] {
    background: ${(props) => props.theme.colors.gray.light};
    border-bottom: 3px solid ${(props) => props.color};
    color: ${(props) => props.color};
  }
`;
